import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

interface DeleteRoomDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  roomName: string;
  taskCount: number;
  onConfirm: () => void;
}

const DeleteRoomDialog = ({
  open,
  onOpenChange,
  roomName,
  taskCount,
  onConfirm,
}: DeleteRoomDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remove &quot;{roomName || "Unnamed Room"}&quot; from this checklist?</AlertDialogTitle>
          <AlertDialogDescription>
            {taskCount > 0
              ? `This will remove the room and its ${taskCount} task${taskCount !== 1 ? "s" : ""} from this checklist only. Tasks are not deleted from the property. To delete or archive the room itself, use the Rooms tab.`
              : "This will remove the room from this checklist only. The room stays in the property. To delete or archive it, use the Rooms tab."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
            Remove from checklist
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteRoomDialog;
